(() => {
  'use strict';

  const valueFormatters = {
    ancho_nominal_mm: (value) => `${value} mm`,
    grosor_mm: (value) => `${String(value).replace('.', ',')} mm`,
    longitud_cm: (value) => `${String(value).replace('.', ',')} cm`,
    unidades_por_envase: (value) => `${value} uds`,
    numero_componentes: (value) => `${value} comp.`,
    numero_modos: (value) => `${value} modos`,
  };

  function humanValue(key, value) {
    if (value === null || value === undefined || value === '') return '';
    if (value === true || value === 'true') return 'Sí';
    if (value === false || value === 'false') return 'No';
    const formatter = valueFormatters[key];
    return formatter ? formatter(value) : String(value);
  }

  function readVariants(root) {
    const node = root.querySelector('[data-cdm-attributes-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (_error) {
      return [];
    }
  }

  function getCurrentVariantId(root) {
    const card = root.closest('product-card');
    if (card) return String(root.dataset.variantId || '');

    const productArea = root.closest('.product-information') || document;
    const input = productArea.querySelector('form[action*="/cart/add"] [name="id"]');
    return input && input.value ? String(input.value) : String(root.dataset.variantId || '');
  }

  function setRowState(node, visible, value) {
    node.hidden = !visible;
    const output = node.querySelector('[data-cdm-attribute-value]');
    if (output) output.textContent = value;
  }

  function update(root) {
    const variantId = getCurrentVariantId(root);
    const variant = readVariants(root).find((item) => String(item.id) === variantId);
    if (!variant) return;

    root.dataset.variantId = variantId;
    const values = variant.values || {};

    root.querySelectorAll('[data-cdm-attribute-badge]').forEach((badge) => {
      const key = badge.dataset.key;
      const value = humanValue(key, values[key]);
      setRowState(badge, Boolean(value), value);
    });

    root.querySelectorAll('[data-cdm-attribute-row]').forEach((row) => {
      const key = row.dataset.key;
      const value = humanValue(key, values[key]);
      setRowState(row, Boolean(value), value);
    });

    root.querySelectorAll('[data-cdm-pdp-context-item], [data-cdm-pdp-essential]').forEach((item) => {
      const key = item.dataset.key;
      const value = humanValue(key, values[key]);
      setRowState(item, Boolean(value), value);
    });
  }

  function initialise(root) {
    update(root);

    const productArea = root.closest('.product-information');
    if (!productArea) return;
    const form = productArea.querySelector('form[action*="/cart/add"]');
    if (!form || form.dataset.cdmAttributesBound === 'true') return;

    form.dataset.cdmAttributesBound = 'true';
    const refresh = () => window.requestAnimationFrame(() => {
      document.querySelectorAll('[data-cdm-attributes]').forEach(update);
    });

    form.addEventListener('change', refresh);
    document.addEventListener('variant:change', refresh);
    document.addEventListener('product:variant-change', refresh);

    const idInput = form.querySelector('[name="id"]');
    if (idInput) {
      let lastValue = idInput.value;
      window.setInterval(() => {
        if (idInput.value !== lastValue) {
          lastValue = idInput.value;
          refresh();
        }
      }, 300);
    }
  }

  function boot() {
    document.querySelectorAll('[data-cdm-attributes]').forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
